<template>
    <div class="background__block">
        <slot></slot>
    </div>
</template>

<script setup></script>

<style lang="scss">
.background__block {
    position: relative;
    top: -77px;
    width: 100%;
}
</style>